<template>
  <Avatar
    :label="abbreviatedName"
    :size="size"
    shape="circle"
    style="min-width: 32px"
  />
</template>

<script lang="ts">
import User from '@/domain/model/business/User.ts';

export default {
  name: 'UserAvatar',
  props: {
    user: {
      type: User,
      required: true,
    },
    size: {
      default: 'normal',
    },
  },
  computed: {
    abbreviatedName() {
      let abr = this.user.firstName.charAt(0) + this.user.lastName.charAt(0);
      return abr.toUpperCase();
    },
  },
};
</script>

<style></style>
